import React, { useEffect, useState } from "react";

/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { vec2 } from "@tlaukkan/tsm";
import { ElementDisplayInfo } from "../../../shared/elementDisplayInfo";
import { GameElement } from "../../../shared/gameElementTypes";
import { cellLocations } from "../../../shared/generated/assetLocations";
import { Colors } from "../palettes/colorPalette";
import { AssetLocation, calculateRoundShopTime } from "../../../shared/utils";
import { GameClient } from "../gameClient";
import { coloredSpritesheet } from "../rendering/spriteFactory";
import { backgroundTexture } from "../uiConstants";
import { getInfectedCellSpawnAmount } from "../../../shared/composition";

declare var gameClient: GameClient;

const containerStyle = css`
    background: url(${backgroundTexture});
    background-color: ${Colors.UIIncomingTab};
    padding: 10px;
    display: flex;
    flex-direction: column;
    width: fit-content;
    border-radius: 14px 0px 0px 14px;
    position: absolute;
    right: 0;
    bottom: 33%;
    transform: translate(0, 0%);
`;

const virusStyle = css`
`

const rowStyle = css`
    display: flex;
`;

const textStyle = css`
    height: fit-content;
    align-self: center;
    margin-left: 0.25vw;
    color: white;
`;

const timerContainerStyle = css`
    color: white;
    animation: height 5s ease;
`;

const timerStyle = css`
    text-align: center;
    font-size: 2vh;
    color: white;
    font-weight: bold;
    font-family: NotoSansDisplay;
    border-bottom: 1px solid;
    margin-bottom: 1vh;
`;

const titleStyle = css`
    color: white;
    font-family: NotoSansDisplay;
    border-bottom: 1px solid;
    margin-bottom: 1vh;
`;

const mutationStyle = css`
    color: white;
    font-family: NotoSansDisplay;
    margin-right: .5vh;
`;

interface NextWaveInfoProps {
    showMutationModel: () => void;
    clearMutationModel: () => void;
}

export const NextWaveInfo = (props: NextWaveInfoProps) => {
    const player = gameClient.getPlayer();
    const [timeleft, setTimeleft] = useState(-1);
    const refTimeleft = React.useRef(timeleft);

    let elapsed = 0;

    /*
    useEffect(() => {
        const interval = setInterval(() => {
            elapsed += 1;
            const total = calculateRoundShopTime(gameClient) / 1000;
            const remaining = total - elapsed;
            refTimeleft.current = remaining;
            setTimeleft(refTimeleft.current);
        }, 1000);
        return () => {
            console.log('clearing interval')
            clearInterval(interval);
        }
    }, [gameClient.getCurrentRound()]);
    */

    // Hacky
    const cellMap = new Array<Map<GameElement, number>>();
    if (player) {
        const waves = gameClient.getVirusWaves(player);
        for (const wave of waves) {
            const type = wave.type;
            const addedAmount = wave.cells
                .map(cell => getInfectedCellSpawnAmount(cell)).reduce((a, b) => a + b, 0);
            const lane = wave.lane;
            cellMap[lane] = cellMap[lane] || new Map<GameElement, number>();
            const currentAmount = cellMap[lane].get(type) || 0;
            cellMap[lane].set(type, currentAmount + addedAmount);
        }
    }

    const buttonImageSize = 24;

    const incomingViruses = [];
    let displayNameNumber = 0; //display by order of appearance nubmer not internal lane number
    for (let i = 0; i < cellMap.length; ++i) {
        const laneMap = cellMap[i];
				if (!laneMap) { continue; } //possible if lane progression goes 0, 2, 1 for example
				++displayNameNumber;
        incomingViruses.push(<div key={`lane_${displayNameNumber}`}>Lane {displayNameNumber}:</div>);
        for (const [virusType, num] of laneMap.entries()) {
            const info = ElementDisplayInfo.get(virusType)!;
            const assetLocation = (cellLocations as any)[info.asset] as AssetLocation;
            const spritesheet = coloredSpritesheet;
            const scaleFactor = buttonImageSize / Math.max(assetLocation.width, assetLocation.height);
            const bgSize = spritesheet.width * scaleFactor;
            const x = assetLocation.x * scaleFactor;
            const y = assetLocation.y * scaleFactor;
            const hover = () => gameClient.setInspection({ element: virusType, position: new vec2() })
            const hoverLeave = () => gameClient.setInspection(null);
            incomingViruses.push(
                <div onMouseEnter={hover} onMouseLeave={hoverLeave} key={`${virusType}_${num}_${i}`} css={rowStyle}>
                    <div title={`${info.asset}`} css={virusStyle} style={{
                        backgroundImage: `url(${spritesheet.src})`,
                        backgroundPosition: `${x}px ${-y}px`,
                        backgroundSize: `${bgSize}px`,
                        display: "inline-block",
                        width: `${assetLocation.width * scaleFactor}px`,
                        height: `${assetLocation.height * scaleFactor}px`,
                    }}></div>
                    <div css={textStyle}>{`×${num}`}</div>
                </div>);
        }
    }

    return (<div css={containerStyle}>
        {refTimeleft.current <= 5 && refTimeleft.current >= 1 &&
            <div css={timerContainerStyle}>
                <div>Next Wave In:</div>
                <div css={timerStyle}>{refTimeleft.current}</div>
            </div>
        }
        <div css={titleStyle} onMouseEnter={props.showMutationModel} onMouseLeave={props.clearMutationModel}>
            <span css={mutationStyle}>
                <FontAwesomeIcon color={Colors.UIIncomingTabText} icon={faInfoCircle} />
            </span>
            Incoming
        </div>
        {
            ...incomingViruses
        }
    </div>);
};

